<template>
  <div class="bg-base-0 upgrade-page">
    <div class="padding">
      <div class="padding">
        <canvas id="firework-canvas" />
        <div class="upgrade-success-content">
          <div class="mt-10">
            <h2 class="px-4 mb-3 text-center">
              AhaSlides {{ $store.state.plan.name }}
            </h2>
            <h2 class="px-4 mb-3 text-center">
              {{ $i18nPresenter.t('Payment successful!') }}
            </h2>
            <div class="text-center congrats-upgrade">
              <i class="fas fa-check-circle fa-3x text-green-50" />
              <p
                class="my-3 congrats-text"
              >
                {{ $i18nPresenter.t('We hope that you will have many successful events with AhaSlides!') }}
              </p>
            </div>
          </div>

          <div class="flex justify-center">
            <aha-button @click="goToMyPresentations">
              <span class="mr-1">{{ backToPresentation.length > 0 ? $i18nPresenter.t( 'Go to my presentation') : $i18nPresenter.t('Go to my presentations') }}</span>
              <span><font-awesome-icon icon="angle-right" /></span>
            </aha-button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="more-information bg-base-0"
    >
      <div class="item-information">
        <div
          class="mt-5 power-by"
        >
          <div class="card-img-logo__wrapper">
            <img src="@/assets/images/image.png" alt class="card-img-logo">
          </div>
          <div class="paypal-stripe__wrapper">
            <img src="@/assets/images/logos/Stripe-logo.svg" alt>
          </div>
        </div>
      </div>
      <div class="item-information">
        <h4 class="mb-1 text-lg font-bold">
          {{ $i18nPresenter.t('We use secure connections') }}
        </h4>
        <p class="text-sm">
          <span v-html="$i18nPresenter.t('weUseHTTPSsecure')"></span>
        </p>
      </div>
      <div class="item-information">
        <h4 class="mb-1 text-lg font-bold">
          {{ $i18nPresenter.t('We do not store credit card information') }}
        </h4>
        <p class="text-sm">
          <span v-html="$i18nPresenter.t('weNeverStoreCreditCardInfomation')">
          </span>
        </p>
      </div>
      <div class="item-information">
        <h4 class="mb-1 text-lg font-bold">
          {{ $i18nPresenter.t('14-day money back guarantees') }}
        </h4>
        <p class="text-sm">
          {{ $i18nPresenter.t(`If you wish to cancel within fourteen (14) days from the day you subscribed, and you have not successfully used AhaSlides at a live event, you will receive a full refund.`) }}
        </p>
      </div>
      <div class="item-information">
        <h4 class="mb-1 text-lg font-bold">
          {{ $i18nPresenter.t('Terms of use') }}
        </h4>
        <p class="text-sm">
          <span v-html="$i18nPresenter.t('readAhaslidesFullTermsOfUse')"></span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import confetti from 'canvas-confetti'
import { mapActions, mapState } from 'vuex'
import Constant from '@/constant'
import Config from '@/config'
import util from '@/util'

export default {
  name: 'CheckoutSuccess',
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      plan: (state) => state.plan,
    }),
    backToPresentation() {
      const backLink = util.getParamValue('back_link_to_presentation', window.location.href)
      return backLink || ''
    },

  },
  async mounted() {
    this.firework()
    await this.getCurrentUserAction()
    this.trackNewPurchaseAction({
      query: this.$route.query,
    })
  },
  methods: {
    ...mapActions(['getCurrentUserAction', 'trackNewPurchaseAction']),
    goToMyPresentations() {
      // Dont use vue-router here, to clean up state and reload full page.
      if (this.backToPresentation.length > 0) {
        return this.$func.go(`${this.backToPresentation}`)
      }
      this.$func.go(`${Config.presenterDomain}/apps/presentations`)
    },
    firework() {
      const self = this
      const canvas = document.getElementById('firework-canvas')
      if (!canvas) return
      canvas.confetti =
          canvas.confetti ||
          confetti.create(canvas, {
            resize: true,
          })
      const colors = Constant.colorsHex.filter((item, key) => {
        return item && key < 7
      })

      const _startFirework = function startFirework() {
        let start = null
        let count = 0
        let timeFirework = 250
        // eslint-disable-next-line
        function step(timestamp) {
          if (count === 3) {
            timeFirework = 800
          }
          if (!start) start = timestamp
          const progress = timestamp - start
          if (progress > timeFirework) {
            start = null
            count++
            canvas.confetti({
              startVelocity: 5,
              spread: 360,
              ticks: 200,
              decay: 0.98,
              particleCount: 80,
              shapes: ['circle'],
              colors,
              zIndex: 100,
              origin: {
                x: Math.random(),
                // since they fall down, start a bit higher than random
                y: Math.random() - 0.3,
              },
            })
          }
          self.myReq = window.requestAnimationFrame(step)
        }
        self.myReq = window.requestAnimationFrame(step)
      }
      _startFirework(false)
    },
  },
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
@import "@/assets/scss/animation.scss";
.upgrade-page {
  max-width: 1024px;
  @apply mx-auto;
}
.fa-trash-alt {
  cursor: pointer;
}
.add-promotion {
  .label-promotion {
    cursor: pointer;
    margin: -18px 0 12px;
  }

  input.form-control {
    border-radius: 5px;
    padding-right: 100px;

    &::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      text-transform: none;
    }
    &::-moz-placeholder {
      /* Firefox 19+ */
      text-transform: none;
    }
    &:-ms-input-placeholder {
      /* IE 10+ */
      text-transform: none;
    }
    &:-moz-placeholder {
      /* Firefox 18- */
      text-transform: none;
    }
  }
  .box-promo {
    position: relative;
    margin-bottom: 4px;

    button.btn {
      position: absolute;
      width: 86px;
      height: 36px;
      font-size: 14px;
      top: 4px;
      right: 6px;
    }
  }
}

.line-invoice.line-invoice-promo {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  margin-bottom: 12px;
  padding-top: 12px;
  margin-top: 12px;
  padding-bottom: 16px;
  .line-value.flex.total-value {
    font-size: 17px;
    font-weight: bold;
  }
  .value-coupon {
    color: $success-color;
  }
  p {
    margin-bottom: 0;
    font-size: 14px;
    color: #888;
  }
}
.secure-notice {
  color: #479a47;
  padding-left: 0.5rem;
  .fas {
    color: inherit;
  }
}
.card-error-text {
  color: #FF4954;
  margin-top: -10px;
}
.show-existing-card {
  font-weight: normal;
  border: 1px solid #ddd;
  padding: 10px;
  font-size: 17px;
  margin-bottom: 24px;
  border-radius: 5px;
  cursor: pointer;

  &.active {
    border-color: $primary-color;

    i {
      color: $primary-color;
    }
  }

  i {
    margin-right: 10px;
  }
}
h5 {
  font-weight: bold;
  font-size: 17px;
}
.card-collapsed {
  visibility: collapse;
  height: 0;
}
.card-form {
  font-weight: bold;
  padding: 18px;
  border: 1px solid #ddd;
  border-radius: 5px;
  width: 100%;
  margin-bottom: 16px;

  h4 {
    font-weight: bold;
  }
  .label-card {
    margin-bottom: 2px;
    color: #666;
  }
  .card-form--label {
    @apply block mb-1 text-base-80 text-base;
    font-size: 1rem;

  }
  @media screen and (min-width:480px) {
    padding: 24px;
  }
}

#card-number,
#card-expiry,
#card-cvc {
  border: 1px solid #ddd;
  height: 40px;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 8px;
}

.power-by {
  @apply flex flex-row items-center justify-center;
  min-height: 34px;

  .card-img-logo {
    max-width: 300px;
    margin-bottom: 8px;
    display: block;
  }

  .paypal-stripe__wrapper {
    @apply flex;
    img {
      margin-bottom: 8px;
      display: block;
      width: 138px;
      position: relative;
    }
  }

  .power-by-paypal {
    @apply pl-2;
    img {
      height: 34px;
      width: auto;
    }
  }

  @media (max-width: 767px) {
    @apply block;
    .card-img-logo__wrapper {
      @apply w-full;
    }
    .paypal-stripe__wrapper {
      max-width: 235px;
      margin: 0 auto;
    }

    a {
      margin: 0 auto;
    }

    img {
      margin: 0 auto;
    }
  }
}

.power-by-hidden {
  display: none;
}

.content-plan {
  min-height: 300px;
  .text-loading .fas {
    font-size: 12px;
  }
}
canvas#firework-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  pointer-events: none;
}

.text-error {
  max-width: 400px;
}
h2 {
  text-align: center;
  font-weight: bold;
  font-size: 30px;
}

.ui-layout {
  max-width: 1036px;
  min-height: 300px;
  margin: 0 auto;
}

.ui-card {
  background-color: #ffffff;
  padding: 20px;
  height: auto;
}

.loading-wrapper {
  width: 100%;
}
.title-block {
  padding-bottom: 24px;
  padding-top: 8px;
}
.title-upgrade {
  @apply my-10 px-4;
  line-height: 2.25rem;
}
.cannot-upgrade-des {
  @apply text-base mb-2;
}
.list-block {
  padding-top: 12px;
}

.content-plan {
  .congrats-text {
    font-size: 16px;
    margin-bottom: 32px;
  }

  .congrats-upgrade {
    margin-bottom: 16px;
  }

  .line-invoice {
    @apply flex flex-row justify-between py-1;
    font-size: 17px;

    .line-label {
      font-weight: bold;
      color: rgba(37, 43, 54, 0.75);
      padding-right: 8px;
    }
    .line-value {

      text-align: right;
      overflow: hidden;
      word-break: break-word;
      &.total-value {
        font-size: 21px;
      }
    }
    .flash-discount {
      @apply text-green-50;
    }

    &.total {
      margin: 16px 0;
      font-weight: bold;

      .line-label {
        color: #000;
      }

      .line-value {
        color: $primary-color;
      }
    }

    &.proration {
      .line-label {
        @apply text-green-50;

      }

      .line-value {
        @apply text-green-50;
      }
    }
  }

  button.btn {
    max-width: 300px;
    width: 100%;
    margin: 0 auto 16px auto;
    font-weight: bold;
    height: 44px;
    font-size: 16px;
  }
}
.upgrade-success-content {
  button.btn {
    margin-bottom: 80px;
  }
  button {
    margin: 0 auto;
  }

  button.btn {
    max-width: 300px;
    width: 100%;
    margin: 0 auto 16px auto;
    font-weight: bold;
    height: 44px;
    font-size: 16px;
  }
}
.more-information {
  @apply p-4 md:p-6;
  max-width: 1024px;
  margin: 0 auto;
  p {
    margin-bottom: 8px;
  }
  .item-information {
    margin-bottom: 16px;
  }
}
.add-coupon-wrapper {
  @apply relative;
  &:hover ::v-deep .aha-input {
    @apply bg-primary-20 border-primary-90;
  }
}
.add-coupon-input {
  ::placeholder { /* Recent browsers */
    text-transform: none;
  }
}

.upgrade-section {
  @apply w-full md:w-1/2 lg:w-5/12 px-5;
  @media screen and (min-width: 1024px) {
    max-width: 420px;
  }
  &.form-section {
    @apply mb-4 md:mb-0;
  }
}

.upgrade-btn {
  @apply w-full;

  // this fix weird flickering when hovering to Upgrade button
  .btn-upgrade--text {
    &.btn-upgrade--text-ok {
      min-width: 24px;
    }
    &.btn-upgrade--text-buy {
      min-width: 66px;
    }
    &.btn-upgrade--text-upgrade {
      min-width: 66px;
    }
  }

}

.add-btn {
  min-width: 1.5rem;
}

.paypal-btn {
  @apply pt-3;
  &.disabled {
    @apply opacity-50 cursor-not-allowed pointer-events-none;
  }
}

.info-box-error {
  @apply mt-4 text-error;
}

.paypal__wrapper-text {
  @apply flex items-center mt-4 pl-1;
}

@media (max-width: 767px) {
  .paypal-btn, .upgrade-btn {
    max-width: 300px;
  }
  .paypal__wrapper-text, .secure-notice {
    max-width: 400px;
  }
  .info-box-error, .paypal__wrapper-text {
    @apply mx-auto;
  }
  .paypal-btn {
    @apply my-0 mx-auto;
  }
}
.text-black-100 {
  color: rgba(0, 0, 0, 1) !important;
}
.icon-tail{
  transform: scaleX(-1);
}
.space-button{
  margin-left: 115px;
}
</style>
